import React from "react";

export const ToolsHeader = () => {
    return (
        <div className="toolsHeader">
            <h2>Tools</h2>
        </div>
    );
};
